import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { ClaimDailyRewardOutput, WebAppRoutes } from "types/web-app";

/**
 * Claims the daily shard reward for the player
 */
export const claimDailyReward = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth(`/${WebAppRoutes.CLAIM_DAILY_REWARD}`, accessToken, {
      method: "POST",
    });

    const data = (await response.json()) as ServiceResponse<ClaimDailyRewardOutput>;

    return data;
  } catch (error) {
    console.error("Error claiming daily reward:", error);
    throw error;
  }
};
